import { types, Instance, SnapshotOut } from "mobx-state-tree";
import api from "services/api/api";

const Coordinates = types.model("coordinates").props({
  coordinates: types.array(types.number),
});

const Model = types.model("ModelDw").props({
  energy: types.maybeNull(types.boolean),
  altitude: types.maybeNull(types.number),
  address: types.maybeNull(types.string),
  id: types.maybeNull(types.string),
  location: types.maybeNull(Coordinates),
  serial: types.maybeNull(types.string),
  connected: types.maybeNull(types.boolean),
  connectedDate: types.maybeNull(types.string),
  group: types.maybeNull(types.string),
});

const Location = types.model("Location").props({
  lat: types.number,
  lng: types.number,
});

export const GatewayAlarmModel = types
  .model("Gateway")
  .props({
    alarms: types.optional(types.array(Model), []),
    locationSelected: types.maybeNull(Location),
    idSelected: types.maybeNull(types.string),
    center: Location,
    isLoading: types.boolean,
  })
  .views((self) => ({
    filterValues(value: string | null) {
      if (value === null) return self.alarms;
      return self.alarms.filter(
        (alarm) =>
          alarm?.id?.toLowerCase().includes(value.toLowerCase()) ||
          alarm?.address?.toLowerCase().includes(value.toLowerCase()) ||
          alarm?.altitude?.toString().includes(value.toLowerCase())
      );
    },
  }))
  .actions((self) => {
    function setAlarms(alarms: any) {
      self.alarms = alarms;
    }
    function setlocationSelected(cordinates: any) {
      self.locationSelected = cordinates;
    }
    function setId(id: any) {
      self.idSelected = self.idSelected === id ? null : id;
    }
    function setCenter(coordinates: any) {
      self.center = coordinates;
    }
    function setLoading(isLoading: any) {
      self.isLoading = isLoading;
    }
    return {
      setAlarms,
      setlocationSelected,
      setLoading,
      setCenter,
      setId,
    };
  })
  .actions((self) => ({
    getDevices: async () => {
      try {
        self.setLoading(true);
        const dw = api.dw;
        const response = await dw.getDevice();
        self.setCenter(response?.center);
        self.setAlarms(response?.devices);
        self.setLoading(false);
      } catch (error) {
        console.log(error);
      }
    },
  }));

type GatewayAlarmModelType = Instance<typeof GatewayAlarmModel>;
export type GatewayAlarm = GatewayAlarmModelType;
type GatewayAlarmSnapshotType = SnapshotOut<typeof GatewayAlarmModel>;
export type GatewayAlarmSnapshot = GatewayAlarmSnapshotType;
export const gatewayDefaultModel = () =>
  types.optional(GatewayAlarmModel, {
    alarms: [],
    locationSelected: null,
    idSelected: null,
    center: { lat: 0, lng: 0 },
    isLoading: false,
  });
